import styled from '@marvelapp/styled';
import { Box } from '@marvelapp/ui';
const Strong = styled(Box).attrs({
    as: 'span',
    fontWeight: 'semibold',
}) ``;
export default Strong;
